const setSelectedChartDisplayType = (state, action) => {
  state.chartDisplayType = action.payload;
};

export default {
  setSelectedChartDisplayType,
};
